import * as React from 'react';

import type {
    GetForm_form_createRules_contact as CreateRulesContactFragment,
    GetForm_form_createRules_account as CreateRulesAccountFragment,
    GetForm_form_createRules_lead as CreateRulesLeadFragment,
} from 'nutshell-graphql-types';

import {isCreateRuleEmpty} from './helpers';

import styles from './create-rules-action-text.module.css';

type Props = {
    createRules:
        | CreateRulesContactFragment
        | CreateRulesAccountFragment
        | CreateRulesLeadFragment
        | null
        | undefined;
};

export function CreateRulesActionText(props: Props) {
    return (
        <div className={styles['action-text']}>
            {isCreateRuleEmpty(props.createRules) ? 'Add rules' : 'Edit rules'}
        </div>
    );
}
